import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, Package, TrendingUp, Clock, CheckCircle2, ArrowRight } from "lucide-react";
import { enquiryStats, listEnquiries, adminListProducts } from "@/lib/adminApi";

function StatCard({ icon: Icon, label, value, color }) {
  return (
    <div className="biosyn-card p-5">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium" style={{ color: "#4A6B82" }}>{label}</p>
          <p className="mt-1 font-heading text-3xl font-extrabold" style={{ color: "#063B63" }}>{value}</p>
        </div>
        <span className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: `${color}18` }}>
          <Icon className="w-6 h-6" style={{ color }} />
        </span>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  const [productCount, setProductCount] = useState(0);

  useEffect(() => {
    enquiryStats().then(setStats).catch(() => {});
    listEnquiries().then((d) => setRecent(d.slice(0, 5))).catch(() => {});
    adminListProducts().then((p) => setProductCount(p.length)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-extrabold" style={{ color: "#063B63" }}>Dashboard</h1>
      <p className="text-sm mt-1" style={{ color: "#4A6B82" }}>Overview of products and customer enquiries.</p>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Inbox} label="Total Enquiries" value={stats?.total ?? "—"} color="#087FBF" />
        <StatCard icon={TrendingUp} label="New Enquiries" value={stats?.new ?? "—"} color="#3FAE35" />
        <StatCard icon={Clock} label="Today" value={stats?.today ?? "—"} color="#16B8D4" />
        <StatCard icon={Package} label="Product Enquiries" value={stats?.product ?? "—"} color="#197A35" />
        <StatCard icon={Clock} label="Pending Follow-ups" value={stats?.followup ?? "—"} color="#e0a800" />
        <StatCard icon={CheckCircle2} label="Converted" value={stats?.converted ?? "—"} color="#3FAE35" />
        <StatCard icon={Package} label="Products" value={productCount} color="#087FBF" />
      </div>

      <div className="mt-8 biosyn-card p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-lg font-bold" style={{ color: "#063B63" }}>Recent Enquiries</h2>
          <Link to="/admin/enquiries" className="text-sm font-semibold flex items-center gap-1" style={{ color: "#087FBF" }}>View all <ArrowRight className="w-4 h-4" /></Link>
        </div>
        {recent.length === 0 ? (
          <p className="text-sm py-6 text-center" style={{ color: "#4A6B82" }}>No enquiries yet.</p>
        ) : (
          <div className="space-y-2">
            {recent.map((e) => (
              <Link key={e.id} to="/admin/enquiries" className="flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 transition-colors">
                <div>
                  <p className="font-semibold text-sm" style={{ color: "#063B63" }}>{e.customer_name}</p>
                  <p className="text-xs" style={{ color: "#4A6B82" }}>{e.product_name || "General"} • {e.mobile}</p>
                </div>
                <span className="text-xs font-mono" style={{ color: "#087FBF" }}>{e.enquiry_number}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
